import { render, staticRenderFns } from "./businessLicense.vue?vue&type=template&id=e93c9a4c"
import script from "./businessLicense.vue?vue&type=script&lang=js"
export * from "./businessLicense.vue?vue&type=script&lang=js"
import style0 from "./businessLicense.vue?vue&type=style&index=0&id=e93c9a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports